module.exports = __webpack_public_path__ + "static/media/quote-no-image.781a87bf.svg";